import * as Sentry from '@sentry/react';

import { getOrgIdAndOrgCode } from 'src/services/api';

export const setSentryOrgIdTag = () =>
  getOrgIdAndOrgCode().then(data =>
    Sentry.setTag('org_id', data.organization_id),
  );
